export const Role = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  VIEWER: 'VIEWER',
  EDITOR: 'EDITOR',
  USER: 'USER'
};

export const widthScreen = window.innerWidth;
export const heightScreen = window.innerHeight;
